module.exports = __webpack_public_path__ + "static/images/containers/EloLeaderboard/images/leaderboard_bg.05fb6520.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/EloLeaderboard/images/leaderboard_bg.jpg
// module id = 3100
// module chunks = 11